<template>
  <div class="r-icon">
    <el-tooltip :disabled="!title" effect="dark" :content="title" :placement="placement">
      <el-button
        style="padding: 0"
        class="btn btn-link"
        @click="handleClick"
        @mouseenter.native="handleHover('on')"
        @mouseleave.native="handleHover"
      >
        <i :class="icon" :style="{ fontSize }" />
      </el-button>
    </el-tooltip>
  </div>
</template>
<script>
/**
 * 图标组件
 * name 必须与图片名一致
 * 使用方式
 * <RIcon title="显示名" name="图片名"/>
 * */
export default {
  name: 'RIcon',
  props: {
    title: String,
    name: String,
    placement: {
      type: String,
      default: 'bottom'
    },
    size: {
      type: String,
      default: '20'
    }
  },
  computed: {
    fontSize() {
      const _fontSize = String(this.size);
      return /px$/.test(_fontSize) ? _fontSize : `${_fontSize}px`
    },
  },
  watch: {
    name(newValue) {
      this.icon = `iconfontpage icon-r-${newValue} icon-default-color`
    }
  },
  data() {
    return {
      icon: this.name ? `iconfontpage icon-r-${this.name} icon-default-color` : '',
    }
  },
  methods: {
    handleHover(ops) {
      this.icon = `iconfontpage icon-r-${this.name} icon-default-color`;
      if(ops === 'on') {
        this.icon = `iconfontpage icon-r-${this.name} icon-hover-color`;
      }
    },
    handleClick() {
      this.$emit('on-select');
    },
  }
}
</script>
<style lang="less" scoped>
  .r-icon {
    padding: 0 10px;
  }
</style>



